var React = require('react');

function ShapeHexagon (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"fill":"currentColor","transform":"translate(109.500000, 124.937500) rotate(90.000000) translate(-109.500000, -124.937500) ","points":"45.3669004 18.1725332 -15 127.110604 49.1330796 233.875 173.63308 231.702467 234 122.765538 169.8669 16"}));
}

ShapeHexagon.defaultProps = {"viewBox":"0 0 219 250","version":"1.1"};

module.exports = ShapeHexagon;

ShapeHexagon.default = ShapeHexagon;
